import { useEffect } from 'react';
import config from 'config';
import { cart, user } from 'core';
import { getRequestId } from 'core/services/bff';
import NotFoundCreditCard from './NotFoundCreditCard';
import { useCreditCard } from './useCreditCard.hooks';
import { getAccessToken } from 'core/services/auth';

const CreditCardForm = () => {
  const { handleIFrameRenderer, handleMessage, isIframeError } = useCreditCard();
  const accessToken = getAccessToken();

  const {
    data: { code: orderCode },
  } = cart.hooks.useCart();

  const {
    data: { brand },
  } = user.hooks.useUser();

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, []);

  if (isIframeError) {
    return <NotFoundCreditCard />;
  }

  return (
    <iframe
      frameBorder="0"
      height="900px"
      onLoad={handleIFrameRenderer}
      scrolling="no"
      src={`${
        config.formCreditCard.baseUrl
      }?token=${accessToken}&orderCode=${orderCode}&brand=${brand}&sessionId=${getRequestId()}`}
      title="Formulário de Cartão de Crédito"
      width="100%"
    />
  );
};

export default CreditCardForm;
